module.exports = __webpack_public_path__ + "static/automation-3d768a2a64de82631932fac630fa4bdf.webp";